<template>
    <main class="main services">
        <div class="container">
            <div class="row">
                <the-filters
                    class="col-md-3"
                    :filters="filters"
                    module-name="settlements"
                    @applyFilters="applyFilters"
                />

                <div class="col-md-9">
                    <div class="c-settings pt-1 mb-3">
                        <h4 class="typo typo--h2">Rozliczenia</h4>
                        <div
                            class="c-settings-filters mt-2 mt-md-0"
                            v-if="settlements && settlements.length > 0"
                        >
                            <div class="d-block ml-3">
                                <results-per-page
                                    :per-page="pagination.perPage"
                                    text="Pokazuj na stronie:"
                                    :on-change="changeResultsPerPage"
                                />
                            </div>
                            <div class="d-block ml-3">
                                <sort-component
                                    text="Sortuj po:"
                                    module-name="settlements"
                                    :options="
                                        $store.getters.getSettlementsSortOptions
                                    "
                                />
                            </div>
                        </div>
                    </div>
                    <header-tabs
                        class="mt-3 mb-4"
                        :content="headerTabs"
                        :active-tab="activeTab"
                        @changeTab="changeTab"
                    />
                    <selected-filters
                        class="my-4"
                        :filters="filters"
                        module-name="settlements"
                        @applyFilters="applyFilters"
                    />
                    <div
                        class="c-promos-refundInfo flex-grow-1 text-sm a-infoBar a-infoBar--warning mb-4"
                        v-text="warningBoxText"
                    />
                    <div class="content mt-4">
                        <div
                            class="
                                d-flex
                                justify-content-between
                                flex-wrap
                                flex-sm-row flex-column
                                pb-3
                            "
                            v-if="isSettlements"
                        >
                            <span class="dropdown mr-4">
                                <the-btn
                                    class="btn btn-secondary"
                                    id="dropdownDownloadNotes"
                                    data-toggle="dropdown"
                                    :text="this.activeTab === 1
                                        ? 'Pobierz dokumenty ponownie'
                                        : 'Pobierz dokumenty'"
                                    icon="Download"
                                    v-click-outside="hideDropdown"
                                    @click.native="showDropdown = !showDropdown"
                                >
                                    <a-icon icon="Dropdown" />
                                </the-btn>

                                <div
                                    class="dropdown-menu"
                                    :class="{ show: showDropdown }"
                                    style="min-width: 100%"
                                    aria-labelledby="dropdownDownloadNotes"
                                >
                                    <button
                                        v-if="activeTab !== 2"
                                        class="dropdown-item"
                                        type="button"
                                        @click="
                                            downloadSettlements(
                                                `Report`,
                                                'filters'
                                            )
                                        "
                                    >
                                        Rozliczeniowe - xls
                                    </button>
                                    <button
                                        v-if="activeTab !== 2"
                                        class="dropdown-item"
                                        type="button"
                                        @click="
                                            downloadSettlements(
                                                `Report`,
                                                'last_month'
                                            )
                                        "
                                    >
                                        Rozliczeniowe - xls (ostatni miesiąc)
                                    </button>
                                    <button
                                        class="dropdown-item"
                                        type="button"
                                        @click="
                                            downloadSettlements(
                                                `Note`,
                                                'filters'
                                            )
                                        "
                                    >
                                        Księgowe - pdf
                                    </button>
                                    <button
                                        v-if="activeTab !== 2"
                                        class="dropdown-item"
                                        type="button"
                                        @click="
                                            downloadSettlements(
                                                `Note`,
                                                'last_month'
                                            )
                                        "
                                    >
                                        Księgowe - pdf (ostatni miesiąc)
                                    </button>
                                </div>
                            </span>
                            <div class="d-flex align-items-end pt-sm-0 pt-3">
                                <div
                                    class="c-promos-all text-right"
                                    v-if="isSettlements"
                                >
                                    <div
                                        class="form-check form-check-inline pr-3 mr-1"
                                    >
                                        <div
                                            class="custom-control custom-checkbox"
                                        >
                                            <ui-checkbox-input
                                                name="selectAllPromos"
                                                v-model="selectAllData"
                                                label="Zaznacz wszystkie"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="c-table notesTable">
                            <div class="c-tbody">
                                <page-preloader
                                    v-if="settlementsStatus === 'loading'"
                                />
                                <template v-else-if="isSettlements">
                                    <settlement-preview
                                        v-for="(settlement, idx) in settlements"
                                        :key="idx"
                                        :data="settlement"
                                        @settlementDownload="
                                            settlementDownloadMethod
                                        "
                                    />
                                </template>
                                <div v-else class="c-td">Brak wyników</div>
                            </div>
                        </div>
                    </div>
                    <div v-if="pagination.totalPages" class="mt-4">
                        {{
                            pagination.totalRecords
                                | plurals('wynik', 'wyniki', 'wyników')
                        }}
                    </div>
                    <div
                        v-if="pagination.totalPages"
                        class="d-flex align-items-center justify-content-between mt-4"
                    >
                        <the-pagination-small
                            :page="toString(pagination.page)"
                            :getter="pagination"
                            :set-method="onChange"
                        />
                        <results-per-page
                            text="Pokazuj na stronie:"
                            :per-page="pagination.perPage"
                            :on-change="changeResultsPerPage"
                        />
                    </div>
                </div>
            </div>
        </div>
        <settlements-bar
            v-if="selectedSettlements.length > 0"
            :data="selectedSettlements"
        />
    </main>
</template>

<script>
import SettlementPreview from '@/components/settlements/SettlementPreview'
import SettlementsBar from '@/components/settlements/SettlementsBar'
import { UiCheckboxInput } from '../components/global/ui'

export default {
    data() {
        return {
            headerTabs: [
                {
                    text: 'Do pobrania',
                    hash: '#available'
                },
                {
                    text: 'Pobrane',
                    hash: '#downloaded',
                    counter: 0
                },
                {
                    text: 'Archiwalne',
                    hash: '#archival'
                }
            ],
            showDropdown: false
        }
    },
    components: {
        SettlementPreview,
        SettlementsBar,
        UiCheckboxInput
    },

    watch: {
        downloadedBundleProgressBar(value) {
            if (
                value &&
                value.finished
            ) {
                if (value.bundle_document_type === 'Note') {
                    this.fetch()
                }
                this.onSettlementsSuccessfullyDownload(value.bundle_document_type)
            }
        },
        settlementsDownloadCounter: {
            immediate: true,
            handler(val) {
                this.headerTabs[1].counter = val
            }
        }
    },
    computed: {
        settlementsDownloadCounter() {
            return this.$store.getters.getSettlementsDownloadCounter
        },
        downloadedBundleProgressBar() {
            return this.$store.getters.getSettlementsProgressBar
        },
        pagination() {
            return this.$store.getters.getSettlementsPagination
        },
        settlements() {
            return this.$store.getters.getSettlements
        },
        settlementsStatus() {
            return this.$store.getters.getSettlementsStatus
        },
        selectedSettlements() {
            return this.$store.getters.getSelectedSettlements
        },
        filters() {
            return this.$store.getters.getSettlementsFilters
        },
        activeTab: {
            get() {
                return this.$store.getters.getSettlementsActiveTab
            },
            async set(value) {
                await this.$store.dispatch('setSettlementsActiveTab', value)
                this.$store.dispatch('selectAllSettlements', false)
                this.$store.commit('SET_SETTLEMENTS_FILTER', {
                    filter: 'parametrization|document_name_id',
                    value: []
                })
                this.$store.dispatch('fetchParametrizationDocumentTypes')
            }
        },
        selectAllData: {
            get() {
                return this.$store.getters.getSettlementsSelectAll
            },
            set(value) {
                this.$store.dispatch('selectAllSettlements', value)
            }
        },
        isSettlements() {
            return this.settlements && this.settlements.length > 0 && this.settlementsStatus === 'idle'
        },
        warningBoxText() {
            return this.activeTab !== 2
                ? 'Pobrane dokumenty trafiają do zakładki pobrane rozliczenia.'
                : 'W tej zakładce znajdują się rozliczenia przeniesione z M/platform. Dotyczy użytkowników korzystających wcześniej z tego rozwiązania.'
        }
    },
    methods: {
        onSettlementsSuccessfullyDownload(documentType) {
            this.$store.dispatch('addNotification', {
                code: 'settlementsDownload',
                onlyOneAllowed: true,
                type: 'success',
                duration: 3000,
                content:
                    documentType === 'Note'
                        ? this.activeTab === 0 ? 'Pobrane dokumenty zostały przeniesione do zakładki "Pobrane"' : 'Dokumenty księgowe zostały pobrane'
                        : 'Raporty rozliczeniowe zostały pobrane'
            })
            this.$store.dispatch('selectAllSettlements', false)
        },
        async settlementDownloadMethod({ documentId, type }) {
            try {
                const res = await this.$store.dispatch('downloadSettlement', { documentId, type })

                if (res?.error) {
                    throw new Error(res.error)
                }

                this.$store.dispatch('addNotification', {
                    code: 'settlementsDownload',
                    onlyOneAllowed: true,
                    type: 'success',
                    duration: 3000,
                    content: type === 'note'
                        ? this.activeTab === 0
                            ? 'Pobrane dokumenty zostały przeniesione do zakładki "Pobrane"' : 'Dokument księgowy został pobrany'
                        : 'Raport rozliczeniowy został pobrany'
                })

                this.$store.dispatch('selectAllSettlements', false)

                if (type === 'note' && this.activeTab === 0) {
                    this.$store.dispatch(
                        'setDownloadedSettlementsCounter',
                        this.settlementsDownloadCounter + 1
                    )
                    this.fetch()
                }
            } catch(err) {
                this.$store.dispatch('addNotification', {
                    type: 'danger',
                    duration: 3000,
                    content: 'Wystąpił błąd podczas pobierania dokumentu'
                })
            }
        },
        changeTab(value) {
            if (this.activeTab === 1 && value !== 1) {
                this.$store.dispatch('setDownloadedSettlementsCounter', null)
            }
            this.activeTab = value
        },
        applyFilters() {
            this.fetch()
        },
        async fetch() {
            this.$store.dispatch('settlementsFetch')
        },
        onChange(page) {
            return this.$router.push({
                query: { ...this.$route.query, page: page },
                hash: this.$router.currentRoute.hash
            })
        },
        changeResultsPerPage(value) {
            return this.$router.push({
                query: { ...this.$route.query, show: value, page: 1 },
                hash: this.$router.currentRoute.hash
            })
        },
        downloadSettlements(bundleType, downloadType) {
            this.$store.dispatch('downloadSettlements', {
                downloadType: downloadType,
                bundleType: bundleType
            })
            this.hideDropdown()
        },
        hideDropdown() {
            this.showDropdown = false
        }
    },
    created() {
        let value
        switch (this.$route.hash) {
        case '#downloaded':
            value = 1
            break
        case '#archival':
            value = 2
            break
        default:
            value = 0
        }
        if (value !== this.activeTab) {
            this.activeTab = value
        }
        this.fetch()
    },
    mounted() {
        if (!this.$store.getters.getUserAllCompaniesData) {
            this.$store.dispatch('fetchAllCompaniesData')
        }
        if (!this.$store.getters.getParametrizationDocumentTypesForFilter?.length) {
            this.$store.dispatch('fetchParametrizationDocumentTypes')
        }
    }
}
</script>
